// extracted by mini-css-extract-plugin
export default {"accordionSection":"accordionSection---cCUzy","finePolicyForm":"finePolicyForm---msakR"};